import VacationStartDayField from "@/pages/employee/permission/vacations/fields/VacationStartDayField.vue";
import VacationEndDayField from "@/pages/employee/permission/vacations/fields/VacationEndDayField.vue";
import VacationCommentField from "@/pages/employee/permission/vacations/fields/VacationCommentField.vue";

export { VacationStartDayField, VacationEndDayField, VacationCommentField };
